export default "__VITE_ASSET__dBpOKx8y__"